/**
 * What the event Overview's Capacity block shows.
 *
 * A pre-registration (Event-in-a-Box) event caps ONLINE registrations with
 * event_ticketing_provisioning.open_issuance_cap (tickets issued, door tickets
 * included). events.max_attendees is a separate, door-side number; showing it
 * as "x / max registered" on those events read as "over capacity" when the
 * real registration limit was nowhere near (tracker 2026-11-04).
 */
export interface CapacityMeter {
  key: "online" | "door" | "capacity";
  label: string;
  used: number;
  limit: number;
  unit: string;
  /** 0..1+, used/limit. */
  ratio: number;
}

export function overviewCapacityMeters(input: {
  maxAttendees: number | null | undefined;
  currentAttendees: number | null | undefined;
  provisioning:
    | {
        registration_mode: string | null;
        open_issuance_cap: number | null;
        issued_count: number | null;
      }
    | null
    | undefined;
}): CapacityMeter[] {
  const meters: CapacityMeter[] = [];
  const prov = input.provisioning;
  const isPreRegistration =
    !!prov &&
    prov.registration_mode === "open" &&
    typeof prov.open_issuance_cap === "number" &&
    prov.open_issuance_cap > 0;
  if (isPreRegistration) {
    const used = prov.issued_count ?? 0;
    const limit = prov.open_issuance_cap as number;
    meters.push({
      key: "online",
      label: "Online registration limit",
      used,
      limit,
      unit: "tickets issued",
      ratio: used / limit,
    });
  }
  const max = input.maxAttendees;
  if (typeof max === "number" && max > 0) {
    const used = input.currentAttendees ?? 0;
    meters.push({
      key: isPreRegistration ? "door" : "capacity",
      label: isPreRegistration ? "Door capacity" : "Capacity",
      used,
      limit: max,
      unit: "registered",
      ratio: used / max,
    });
  }
  return meters;
}
